<script lang="ts">
  import { twMerge } from "tailwind-merge";
  import { onMount } from "svelte";

  export let css = "";
  export let toc: { text: string; id: string }[] = [];

  let activeId: string | null = null;

  // highlight the active toc item
  onMount(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activeId = entry.target.id;
          }
        });
      },
      { rootMargin: "-100px 0px -66%" },
    );

    toc.forEach(({ id }) => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  });

  function handleClick(e: MouseEvent, id: string) {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }
</script>

{#if toc.length > 0}
  <div class={twMerge("mb-8 text-sm", css)}>
    <div class="mb-4 font-medium uppercase text-blog-gray-600 dark:text-blog-gray-400">Table Of contents</div>

    <nav class="flex flex-col space-y-3 font-light text-blog-gray-900 dark:text-blog-gray-300">
      {#each toc as item}
        <a
          href={`#${item.id}`}
          on:click={(e) => handleClick(e, item.id)}
          class={twMerge(
            "transition-colors hover:text-black hover:underline dark:hover:text-white",
            activeId === item.id && "font-bold text-black dark:text-white",
          )}
        >
          {item.text}
        </a>
      {/each}
    </nav>
  </div>
{/if}
